import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';

import { administrationRoutes } from 'pages/Settings/Administration/AdministrationPage';
import { Outlet } from 'react-router-dom';
import ConfigurationManagement from './ConfigurationManagement';
import { discoverySnapshotsRoutes } from './DiscoverySnapshots/DiscoverySnapshotsPage';
import { integrationRoutes } from './Integration/IntegrationPage';
import { systemRoutes } from './System/SystemPage';

export const settingsRoutes: RoutesTreeItem[] = [
  {
    path: '/settings/discovery-snapshots',
    element: <Outlet />,
    children: discoverySnapshotsRoutes,
  },
  {
    path: '/settings/configuration-management',
    element: <ConfigurationManagement />,
    requiredApiScope: { method: 'GET', path: '/settings' },
  },
  {
    path: '/settings/integration',
    element: <Outlet />,
    children: integrationRoutes,
  },
  {
    path: '/settings/system',
    element: <Outlet />,
    children: systemRoutes,
  },
  {
    path: '/settings/administration',
    element: <Outlet />,
    children: administrationRoutes,
  },
];
